export default "__VITE_ASSET__Cxv99AQu__";